export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téléphone"])},
        "no_referent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun référent"])}
      },
      "en": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone"])},
        "no_referent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No referent"])}
      }
    }
  })
}
